import { render, staticRenderFns } from "./FeaturedCollections.vue?vue&type=template&id=4efad9c2&scoped=true&"
import script from "./FeaturedCollections.vue?vue&type=script&lang=js&"
export * from "./FeaturedCollections.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedCollections.vue?vue&type=style&index=0&id=4efad9c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efad9c2",
  null
  
)

export default component.exports